import axios from "axios";

// get products by category
export const getProductsBysubCategory = async (subcategoryId) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/products-handler/?subcategory_id=${subcategoryId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};